<template>
  <div class="new-journal redesign">
    <Header />
    <slot />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/newRedesign/HeaderNewCopy";
import Footer from "@/components/newRedesign/FooterNewCopy";

export default {
  name: "Default",
  components: {
    Header,
    Footer
  }
};
</script>
